// ── Countdown Timer ───────────────────────────────────────
(function() {
  var endKey = 'hb_countdown_end';
  var end = parseInt(localStorage.getItem(endKey), 10);
  var now = Date.now();

  if (!end || end < now) {
    end = now + 13 * 60 * 1000; // 13 minutes
    localStorage.setItem(endKey, end);
  }

  var el = document.getElementById('countdown');
  if (!el) return;

  function tick() {
    var diff = Math.max(0, end - Date.now());
    var m = Math.floor(diff / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    el.textContent = pad(m) + ':' + pad(s);
    if (diff <= 0) {
      end = Date.now() + 13 * 60 * 1000;
      localStorage.setItem(endKey, end);
    }
  }

  function pad(n) { return n < 10 ? '0' + n : n; }
  tick();
  setInterval(tick, 1000);
})();

// ── Scroll Fade-In ────────────────────────────────────────
(function() {
  var els = document.querySelectorAll('.fade-in');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el) { el.classList.add('visible'); });
    return;
  }
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function(el) { obs.observe(el); });
})();

// ── Buy Now — skip cart, go straight to checkout ──────────
(function() {
  document.querySelectorAll('.js-buy-form').forEach(function(form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      var btn = form.querySelector('.btn-buy');
      var original = btn.innerHTML;
      btn.innerHTML = 'Processing…';
      btn.disabled = true;

      try {
        var resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(form.dataset.variantId, 10),
            quantity: 1
          })
        });

        if (!resp.ok) throw new Error('cart error');

        // Fire tracking
        if (typeof fbq !== 'undefined') fbq('track', 'InitiateCheckout');
        if (typeof gtag !== 'undefined') {
          gtag('event', 'begin_checkout', { currency: 'EUR' });
          gtag('event', 'conversion', { send_to: 'AW-18202652766/IZxgCPWkuLgcEN7g2edD', value: 14.05, currency: 'EUR' });
        }

        window.location.href = '/checkout';
      } catch(err) {
        btn.innerHTML = original;
        btn.disabled = false;
        alert('Something went wrong. Please try again.');
      }
    });
  });
})();
